<template>
  <div class="container_box">
    <Tabs v-model="pageParam.status" :animated="false" class="tabs_styles" @on-click="changeTab">
      <TabPane v-for="item in statusList" :label="handleLable(item)" :name="item.value"></TabPane>
    </Tabs>
    <!--头部筛选区域-->
    <div class="filter_box">
      <Form ref="pageParam" :model="pageParam" :label-width="labelWidth" @submit.native.prevent>
        <Row type="flex" :gutter="gutterItem">
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1003280')" prop="name">
              <Input v-model.trim="pageParam.name" clearable :placeholder="$t('key1003281')"></Input>
            </FormItem>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1000473')" prop="attributeType">
              <Select v-model="pageParam.attributeType">
                <Option v-for="item in attributeTypeList" :key="item.value" :value="item.value">{{ item.title }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1000476')" prop="attributeRequire">
              <Select v-model="pageParam.attributeRequire">
                <Option v-for="item in attributeRequireList" :key="item.value" :value="item.value">{{ item.title }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1003282')" prop="isAllowCustomValue">
              <Select v-model="pageParam.isAllowCustomValue">
                <Option v-for="item in isAllowCustomValueList" :key="item.value" :value="item.value">{{ item.title }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1003283')" prop="chooseType">
              <Select v-model="pageParam.chooseType">
                <Option v-for="item in chooseTypeList" :key="item.value" :value="item.value">{{ item.title }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1000477')" prop="isSizeAttribute">
              <Select v-model="pageParam.isSizeAttribute">
                <Option v-for="item in isSizeAttributeList" :key="item.value" :value="item.value">{{ item.title }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1000472')" prop="ymsSiteId">
              <Select v-model="pageParam.ymsSiteId">
                <Option v-for="item in ymsSiteList" :key="item.ymsSiteId" :value="item.ymsSiteId">{{ item.siteName }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col style="min-width: 200px;" push="1">
            <Button @click="reset" icon="md-refresh" class="mr12">{{ $t('key1000109') }}</Button>
            <Button type="primary" @click="search" icon="md-search">{{ $t('key1000361') }}</Button>
          </Col>
        </Row>
      </Form>
    </div>
    <!--功能按钮操作区域-->
    <div class="operation_box flex align-items-center justify-content-between">
      <div class="flex align-items-center">
        <!--新增模板-->
        <Button
          type="primary"
          @click="$refs['attrModal'].initAttributesData('add')"
          class="mr15"
          v-if="getPermission('ymsProductAttributeTemplate_insert')">
          {{ $t('key1000428') }}
        </Button>
        <!--导入-->
        <Button
          class="mr15"
          type="primary"
          @click="$refs.commonImport.importModal = true"
          v-if="getPermission('ymsProductAttributeTemplate_excelImport')">
          {{ $t('key1000329') }}
        </Button>
        <!--导出数据-->
        <Dropdown transfer @on-click="changeExportBtn" class="mr15"
          v-if="getPermission('ymsProductAttributeTemplate_exportTemplatr')">
          <Button>
            <span>{{ $t('key1003082') }}</span>
            <Icon type="ios-arrow-down"></Icon>
          </Button>
          <DropdownMenu slot="list">
            <DropdownItem name="1">{{ $t('key1003083') }}</DropdownItem>
            <DropdownItem name="2">{{ $t('key1003084') }}</DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </div>
      <div class="flex align-items-center">
        <!--自定义列-->
        <Button @click="$refs['customColumns'].initCustomColumnsData()">{{ $t('key1000977') }}</Button>
      </div>
    </div>
    <!--列表区域-->
    <div class="table_box">
      <Table
        ref="selection"
        highlight-row
        border
        :loading="tableLoading"
        max-height="450"
        @on-selection-change="tableChange"
        :columns="tableColumns"
        :data="pageTableData"
        @on-sort-change="sortChange">
      </Table>
      <Page
        :transfer="true"
        v-if="!tableLoading"
        :total="tableData.length"
        :current="page.pageNum"
        :page-size="page.pageSize"
        show-total
        show-sizer
        show-elevator
        placement="top"
        @on-change="localChangePage"
        @on-page-size-change="localChangePageSize"
        :page-size-opts="pageArray"/>
    </div>
    <!--新增属性弹窗-->
    <addAttributes
      ref="attrModal"
      attributeTalg="associationProperty"
      :ymsSiteList="ymsSiteList"
      @updateData="pageParamsStatus = true">
    </addAttributes>
    <!--导入的弹窗-->
    <commonImportModal
      ref="commonImport"
      :importTitle="$t('key1003284')"
      :uploadAction="uploadZoneExcel"
      @uploadSuccess="pageParamsStatus = true"
      importTemplateKey="ymsProductAttributeTemplate">
      {{ $t('key1002622') }}<br/>
      {{ $t('key1002623') }} .xls .xlsx .csv;<br/>
      {{ $t('key1003286') }}<br/>
    </commonImportModal>
    <!--自定义列组件-->
    <customColumnsDrawer
      ref="customColumns"
      customColumnsKey="itemAttributesColumns"
      :originalColumns="originalColumns"
      :defaultSelectKeyList="defaultSelectKeyList"
      @customColumnsData="customColumnsData">
    </customColumnsDrawer>
    <!--导出数据字段弹窗-->
    <exportFieldsModal
      ref="exportFields"
      :exportFieldsTitle="$t('key1003285')"
      paramKeyColums="ymsProductAttributeTemplateHandlerColumns"
      :customFieldExportList="customFieldExportList"
      @exportFieldsDataBtn="exportFieldsDataBtn">
    </exportFieldsModal>
    <!--日志弹窗-->
    <commonLogModal
      modalWidth="1200"
      ref="commonLog"
      logMode="ATTRIBUTE_POOL"
      :logType="['PRODUCT_ATTRIBUTE_LOG']">
    </commonLogModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import addAttributes from "@/components/common/addAttributes";
import commonImportModal from "@/components/common/commonImportModal";
import customColumnsDrawer from "@/components/common/customColumnsDrawer";
import exportFieldsModal from "@/components/common/exportFieldsModal";
import {pageJump, getYmsSiteData, getDataSetBatchList, getEnumName, getEnumList} from "@/utils/common";
import commonLogModal from "@/components/common/commonLogModal.vue";

export default {
  name: "itemAttributes",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      pageParamsStatus: false,
      pageParam: {
        attributeRequire: 'null', // 属性填写要求，0：必填，1：非必填，2：选填
        attributeType: 'null', // 属性类型(0:基础属性 1:规格属性 null 全部)
        chooseType: 'null', // 可选值类型定义 0:多选 1:单选
        isAllowCustomValue: 'null', // 是否允许自定义属性值(0:不允许 1:允许)
        isSizeAttribute: 'null', // 是否尺码属性，0：否，1：是
        name: '',
        status: '1', // 状态 0 停用 1 启用
        orderBy: 'createdTime',
        upDown: 'down',
        ymsSiteId: null,
      },
      tableData: [],
      tableColumns: [],
      originalColumns: [
        {
          type: 'selection',
          width: 60,
          key: 'idx',
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003257'),
          key: 'index',
          width: 80,
          align: 'center',
          type: 'index',
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000396'),
          key: 'cnName',
          minWidth: 150,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000461'),
          key: 'status',
          minWidth: 100,
          align: 'center',
          render(h, params) {
            let status = params.row.status;
            let text = '';
            v.statusList.map((item) => {
              if (Number(item.value) === status) {
                text = item.name;
              }
            });
            return h('span', {class: status === 1 ? 'openStatus' : 'stopStatus'}, text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003258'),
          key: 'attributeType',
          minWidth: 150,
          align: 'center',
          render(h, params) {
            let attributeType = params.row.attributeType;
            let text = '';
            v.attributeTypeList.map((item) => {
              if (item.value === attributeType) {
                text = item.title;
              }
            });
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000397'),
          key: 'type',
          minWidth: 150,
          align: 'center',
          render(h, params) {
            let type = params.row.type;
            let text = getEnumName(v.enumData, 'YmsProductAttributeValueTypeCoreEnum', type);
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003259'),
          key: 'isSizeAttribute',
          minWidth: 150,
          align: 'center',
          render(h, params) {
            let isSizeAttribute = params.row.isSizeAttribute;
            let text = '';
            v.isSizeAttributeList.map((item) => {
              if (item.value === isSizeAttribute) {
                text = item.title;
              }
            });
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000399'),
          key: 'attributeRequire',
          minWidth: 100,
          align: 'center',
          render(h, params) {
            let attributeRequire = params.row.attributeRequire;
            let text = '';
            v.attributeRequireList.map((item) => {
              if (item.value === attributeRequire) {
                text = item.title;
              }
            });
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000398'),
          key: 'isAllowCustomValue',
          minWidth: 150,
          align: 'center',
          render(h, params) {
            let type = params.row.type;
            let isAllowCustomValue = Number(params.row.isAllowCustomValue);
            let text = '-';
            if (type !== 0) {
              v.isAllowCustomValueList.map((item) => {
                if (item.value === isAllowCustomValue) {
                  text = item.title;
                }
              });
            }
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000400'),
          key: 'chooseType',
          minWidth: 120,
          align: 'center',
          render(h, params) {
            let chooseType = params.row.chooseType;
            let type = params.row.type;
            let text = '-';
            if (type !== 0) {
              v.chooseTypeList.map((item) => {
                if (item.value === chooseType) {
                  text = item.title;
                }
              });
            }
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002159'),
          key: 'createdTime',
          width: 170,
          align: 'center',
          sortable: 'custom',
          sortType: 'desc',
          render(h, params) {
            return h('span', v.$uDate.dealTime(params.row.createdTime, 'fulltime'));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          key: 'options',
          align: 'center',
          width: 300,
          render(h, params) {
            let status = params.row.status;
            let attributeType = params.row.attributeType; // 只有普通属性的才可以操作启用、停用
            let ymsProductAttributeTemplateId = params.row.ymsProductAttributeTemplateId;
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000401'),
                    show: v.getPermission('ymsProductAttributeTemplate_detail'),
                    clickFn: () => {
                      v.$refs['attrModal'].initAttributesData('look', ymsProductAttributeTemplateId);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000985'),
                    show: v.getPermission('ymsProductAttributeTemplate_update'),
                    clickFn: () => {
                      v.$refs['attrModal'].initAttributesData('edit', ymsProductAttributeTemplateId);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000105'),
                    show: v.getPermission('ymsProductAttributeTemplate_delete'),
                    clickFn: () => {
                      v.deleteAttribute(ymsProductAttributeTemplateId);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000463'),
                    show: status === 1 && v.getPermission('ymsProductAttributeTemplate_disable') && attributeType === 0,
                    clickFn: () => {
                      v.enableDisableBtn(ymsProductAttributeTemplateId, 'disable');
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000462'),
                    show: status === 0 && v.getPermission('ymsProductAttributeTemplate_enable') && attributeType === 0,
                    clickFn: () => {
                      v.enableDisableBtn(ymsProductAttributeTemplateId, 'enable');
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002478'),
                    show: true,
                    clickFn: () => {
                      v.$refs['commonLog'].initCommonLogData(ymsProductAttributeTemplateId);
                    }
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ],
      uploadZoneExcel: api.post_ymsProductAttributeTemplate_excelImport,
      excleFile: null,
      statusList: [
        {
          value: 'null',
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110'),
          paramsKey: 'totalCount',
          quantity: 0
        },
        {
          value: '1',
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002630'),
          paramsKey: 'enableCount',
          quantity: 0
        },
        {
          value: '0',
          name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002631'),
          paramsKey: 'disableCount',
          quantity: 0
        }
      ],
      attributeRequireList: [
        {value: 'null', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110')},
        {value: 0, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000304')},
        {value: 1, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000305')},
        {value: 2, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000306')}
      ],
      isAllowCustomValueList: [
        {value: 'null', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110')},
        {value: 1, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000392')},
        {value: 0, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000393')},
      ],
      chooseTypeList: [
        {value: 'null', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110')},
        {value: 1, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000394')},
        {value: 0, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000395')},
      ],
      isSizeAttributeList: [
        {value: 'null', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110')},
        {value: 1, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000392')},
        {value: 0, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000393')},
      ],
      selectTableData: [],
      defaultSelectKeyList: ['index', 'idx', 'options'],
      setColumnsList: [],
      exportType: '1',
      customFieldExportList: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000399'),
          titleKey: 'fillingRequirementsColums',
          selectList: [], // 选中导出字段的key
          checkBoxList: [
            {paramKey: 'attributeType', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003260')},
            {paramKey: 'type', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003261')},
            {paramKey: 'chooseType', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003262')},
            {paramKey: 'isSizeAttribute', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003263')},
            {paramKey: 'attributeRequire', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003264')},
            {paramKey: 'isUnitType', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000397')},
          ]
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003265'),
          titleKey: 'attributeInfoColums',
          selectList: ['sortNo', 'cnName'], // 选中导出字段的key
          checkBoxList: [
            {paramKey: 'sortNo', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003257'), disabled: true},
            {paramKey: 'cnName', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003266'), disabled: true},
            {paramKey: 'usName', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000430')},
            {paramKey: 'ukName', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000431')},
            {paramKey: 'auName', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000432')},
            {paramKey: 'euName', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000433')},
            {paramKey: 'frName', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003267')},
            {paramKey: 'deName', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003268')},
            {paramKey: 'esName', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003269')},
            {paramKey: 'nlName', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003270')},
            {paramKey: 'plName', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003271')},
            {paramKey: 'ptName', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003272')},
            {paramKey: 'itName', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003273')},
            {paramKey: 'status', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003274')}
          ]
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003275'),
          titleKey: 'attributeValueInfoColums',
          selectList: [], // 选中导出字段的key
          checkBoxList: [
            {paramKey: 'cnValue', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003266')},
            {paramKey: 'usValue', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000430')},
            {paramKey: 'ukValue', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000431')},
            {paramKey: 'auValue', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000432')},
            {paramKey: 'euValue', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000433')},
            {paramKey: 'frValue', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003267')},
            {paramKey: 'deValue', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003268')},
            {paramKey: 'esValue', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003269')},
            {paramKey: 'nlValue', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003270')},
            {paramKey: 'plValue', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003271')},
            {paramKey: 'ptValue', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003272')},
            {paramKey: 'itValue', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003273')},
            {paramKey: 'attributeValueStatus', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000461')}
          ]
        }
      ],
      ymsSiteList: [],
      page: {
        pageNum: 1,
        pageSize: 50,
      },
      enumData: []
    };
  },
  computed: {
    pageTableData() {
      let v = this;
      v.tableLoading = false;
      let start = (v.page.pageNum - 1) * v.page.pageSize;
      let end = (v.page.pageNum - 1) * v.page.pageSize + v.page.pageSize;
      return v.tableData.slice(start, end);
    },
    attributeTypeList() {
      const ENUM_KEY = 'YmsProductAttributeTemplateAttributeTypeCoreEnum';
      let list = getEnumList(this.enumData, ENUM_KEY, 'number');
      list.unshift({
        value: 'null',
        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110')
      });
      return list;
    }
  },
  created() {
    this.initFun();
  },
  methods: {
    // 初始化数据
    initFun() {
      let v = this;
      (async () => {
        let enumKeyList = [
          'YmsProductAttributeValueTypeCoreEnum',
          'YmsProductAttributeTemplateAttributeTypeCoreEnum'
        ];
        v.enumData = await getDataSetBatchList(enumKeyList);
        await getYmsSiteData().then((list) => {
          v.ymsSiteList = list;
          v.pageParam.ymsSiteId = v.ymsSiteList[0].ymsSiteId;
        });
        await v.handleColumns();
        await v.getAttributePoolsNum();
        await v.search();
      })();
    },
    // 查询按钮
    search() {
      this.pageParamsStatus = true;
    },
    // 重置按钮
    reset() {
      let v = this;
      v.$refs['pageParam'].resetFields();
      v.pageParam.ymsSiteId = v.ymsSiteList[0].ymsSiteId;
      v.getList();
    },
    // 参数处理
    handleParameter() {
      let v = this;
      let params = Object.assign({}, v.pageParam);
      let keyList = ['status', 'attributeRequire', 'attributeType', 'chooseType', 'isAllowCustomValue', 'isSizeAttribute'];
      for (let key of keyList) {
        params[key] = v.pageParam[key] === 'null' ? null : Number(v.pageParam[key]);
      }
      return params;
    },
    // 获取列表的数据
    getList() {
      let v = this;
      v.tableData = [];
      v.page.pageNum = 1;
      if (v.getPermission('ymsProductAttributeTemplate_query')) {
        v.tableLoading = true;
        v.axios.post(api.post_ymsProductAttributeTemplate_query, v.handleParameter()).then(response => {
          v.tableLoading = false;
          if (response.data.code === 0) {
            v.tableData = response.data.datas || [];
            v.$nextTick(() => {
              v.tableLoading = false;
            });
          } else {
            v.tableLoading = false;
          }
        });
      } else {
        v.gotoError();
      }
    },
    // 前端分页
    localChangePage(page) {
      let v = this;
      v.page.pageNum = page;
    },
    localChangePageSize(pageSize) {
      this.setPageSizeStorage(pageSize);
      this.page.pageSize = pageSize;
      this.tableLoading = true;
    },
    // 获取属性池对应状态的数量
    getAttributePoolsNum() {
      let v = this;
      v.axios.get(api.get_ymsProductAttributeTemplate_queryCount).then(res => {
        if (res.data.code === 0) {
          let data = res.data.datas;
          if (data) {
            v.statusList.map((item) => {
              item.quantity = data[item.paramsKey];
            });
          }
        }
      });
    },
    // 处理属性池的数量
    handleLable(data) {
      return data.name + (data.quantity ? `(${data.quantity})` : '');
    },

    // 删除属性
    deleteAttribute(ymsProductAttributeTemplateId) {
      let v = this;
      v.$Modal.confirm({
        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003276'),
        content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003277'),
        okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000111'),
        cancelText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000112'),
        onOk: () => {
          v.axios.delete(api.delete_ymsProductAttributeTemplate + `${ymsProductAttributeTemplateId}`,
            {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
            if (response.data.code === 0) {
              v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002957'));
              setTimeout(() => {
                v.pageParamsStatus = true;
              }, 500);
            }
          });
        },
        onCancel: () => {
        }
      });
    },
    // 勾选列表数据
    tableChange(data) {
      this.selectTableData = [];
      if (data && data.length > 0) {
        data.map((item) => {
          this.selectTableData.push(item.ymsProductAttributeTemplateId);
        });
      }
    },
    // 处理列表字段
    handleColumns(data) {
      let v = this;
      v.optionBtnWidth = [];
      let hideKeyColumns = [];
      let obj = {
        '1': ['status'],
        '0': ['status']
      };
      hideKeyColumns = obj[v.pageParam.status] || [];
      let sortKeyList = data || v.setColumnsList;
      let list = v.handleCustomColumnsSort(sortKeyList, hideKeyColumns, v.originalColumns, v.defaultSelectKeyList);
      if (list.length > 0) {
        v.tableColumns = list;
      } else {
        v.tableColumns = v.originalColumns.filter((item) => {
          return !hideKeyColumns.includes(item.key);
        });
      }
      v.updateTableDom('selection');
    },
    // 获取当前列表设置展示的字段
    customColumnsData(data) {
      this.setColumnsList = data;
      this.handleColumns(data);
    },
    // 选择导出数据类型  1 按选中导出 2 按查询结果导出
    changeExportBtn(value) {
      this.exportType = value;
      if (value === '1') {
        if (this.selectTableData.length <= 0) {
          this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003077'));
          return false;
        }
      } else {
        if (this.tableData.length <= 0) {
          this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003078'));
          return false;
        }
      }
      this.$refs['exportFields'].getExportFieldsSetting();
    },
    // 导出数据
    exportFieldsDataBtn() {
      let v = this;
      let query = v.handleParameter();
      if (v.exportType === '1') {
        query.ymsProductAttributeTemplateIds = v.selectTableData;
      } else {
        query.ymsProductAttributeTemplateIds = [];
      }
      v.$refs['exportFields'].saveExportFieldsSetting().then((data) => {
        if (data) {
          v.axios.post(api.post_ymsProductAttributeTemplate_exportTemplatr, query,
            {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(res => {
            if (res.data.code === 0) {
              v.$refs['exportFields'].exportFieldsModal = false;
              let taskNumber = res.data.datas;
              setTimeout(() => {
                pageJump('/yms.html#/exportTask?operateCode=' + taskNumber, '/yms-core-service', '_blank');
              }, 30);
            }
          });
        }
      });
    },
    // 启用、停用属性
    enableDisableBtn(ymsProductAttributeTemplateId, type) {
      let v = this;
      // 停用
      if (type === 'disable') {
        v.$Modal.confirm({
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003006'),
          content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003278'),
          okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003279'),
          onOk: () => {
            v.axios.put(api.put_ymsProductAttributeTemplate_disable + ymsProductAttributeTemplateId, null,
              {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
              if (response.data.code === 0) {
                v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002486'));
                updateData();
              }
            });
          },
          onCancel: () => {
          }
        });
      }
      // 启用
      else {
        v.axios.put(api.put_ymsProductAttributeTemplate_enable + ymsProductAttributeTemplateId, null,
          {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
          if (response.data.code === 0) {
            v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002485'));
            updateData();
          }
        });
      }

      function updateData() {
        setTimeout(() => {
          v.getAttributePoolsNum();
          v.pageParamsStatus = true;
        }, 100);
      }
    },
    // 创建时间排序
    sortChange(data) {
      let obj = {
        desc: 'down',
        asc: 'up'
      };
      this.pageParam.upDown = obj[data.order];
      this.pageParam.orderBy = data.key;
      this.pageParamsStatus = true;
    },
    // 切换Tab
    changeTab() {
      let v = this;
      v.handleColumns();
      setTimeout(() => {
        v.pageParamsStatus = true;
      }, 50);
    }
  },
  watch: {
    pageParamsStatus(value) {
      let v = this;
      if (value) {
        v.getList();
        v.pageParamsStatus = false;
      }
    }
  },
  components: {
    commonLogModal,
    addAttributes,
    commonImportModal,
    customColumnsDrawer,
    exportFieldsModal
  }
};
</script>

<style lang="less" scoped>

</style>
